/**
 * 品牌配置文件
 * 注意: downloadUrl 现在从 API 动态获取,存储在 configStore 中
 * 这里只保留品牌相关的静态配置(title, url, addrs)
 */
interface Config {
  dtiyu: { title: string; url: string; addrs: string }
  dkqiu: { title: string; url: string; addrs: string }
  bishow: { title: string; url: string; addrs: string }
}

const config: Config = {
  dtiyu: { title: '懂球体育', url: 'https://download.dtiyu.com', addrs: 'https://dqtiyu.com' },
  dkqiu: { title: '懂看球', url: 'https://download.dkqiu.com', addrs: 'https://dkqiu.com' },
  bishow: { title: '必搜', url: 'https://download.bishow.tv', addrs: 'https://bishow.tv' }
}

export default config
